import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import AsyncSelect from "react-select/async";

const PurposeVisitCreateModal = ({ povId, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [locationsOptions, setlocationsOptions] = useState(null);
  const [multipleGatein, setmultipleGatein] = useState(false);
  const handleAssignToDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    setlocationsOptions(selectedOptions);
  };
  const modalStyle = {
    overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
    modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", height: "450px", overflowY: "auto" },
  };

  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [duration, setDuration] = useState("");
  useEffect(() => {
    if (povId != null) {
      getPOVDetails();
    }
  }, []);

  const multiselectCustomStyles = {
    control: (provided) => ({ ...provided, backgroundColor: "#ffffff", borderRadius: "8px", border: "0.7px solid #E5E5E5", padding: "2px", fontWeight: "500", fontSize: "13px", color: "#212129" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff", color: state.isSelected ? "#fff" : "#333", padding: 10 }),
    multiValue: (provided) => ({ ...provided, backgroundColor: "#F6F7F8", color: "#212129", borderRadius: "5px", padding: "2px 5px" }),
    multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
    multiValueRemove: (provided) => ({ ...provided, color: "#212129", cursor: "pointer", ":hover": { backgroundColor: "red", color: "white" } }),
  };

  const fetchOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getLocationListApi(inputValue);
      if (response.status === 200 && response.data.success) {
        const options = response.data.suggestionlist.map((item) => ({ value: String(item.value), label: String(item.label) }));
        callback(options);
      }
    }, 1000);
  };

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    description: "",
    duration: "",
  });

  const getPOVDetails = async () => {
    try {
      const response = await getPOVDetailsApi(povId);
      if (response.status === true) {
        console.log(response);
        var povDetails = response.Purpose_of_visit;
        console.log(povDetails);
        setCode(povDetails.code ?? "");
        setName(povDetails.name ?? "");
        setDescription(povDetails.description ?? "");
        setDuration(povDetails.duration ?? "");
        setlocationsOptions(povDetails.locations?.map((item) => ({ value: String(item.id), label: String(item.location) })));
        setmultipleGatein(povDetails.multiple_gate_in ?? false);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const submitPurposeVisit = async () => {
    const dataBeforeSanitize = {
      id: povId != null ? povId : "",
      code: code,
      name: name,
      description: description,
      duration: duration,
      locations: locationsOptions?.filter((item) => item.value !== "").map((item) => item.value),
      multiple_gate_in: multipleGatein,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (povId == null) {
      const response = await createPOVApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data);
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            description: "",
            duration: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updatePOVApi(dataAfterSanitize, povId);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data);
        }
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            description: "",
            duration: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  const [lastKey, setLastKey] = useState("");
  const handleChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key);
      if (lastKey === "Backspace") {
        setDuration(inputText);
      } else {
        setDuration(inputText.length === 2 ? inputText + ":" : inputText);
      }
    }
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div className="modal-header style-justify-between">
            <div className="add-item-modal-title">{povId != null ? "Edit " : "Add "} purpose of visit</div>
            <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
          </div>
          <div style={{ padding: "16px 24px" }}>
            <Row style={{ width: "670px" }}>
              <Col xs={12} sm={12} md={6}>
                <div className="field-title">
                  Code<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                <span className="field-error">{validations.code}</span>
              </Col>
              <Col xs={12} sm={12} md={6}>
                <div className="field-title">
                  Name<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
                <span className="field-error">{validations.name}</span>
              </Col>
              <Col sm={6}>
                <div className="field-title mb-2 mt-3">Location</div>
                <AsyncSelect isMulti cacheOptions value={locationsOptions} loadOptions={fetchOptions} onChange={handleAssignToDropdownChange} defaultOptions placeholder="Search location..." styles={multiselectCustomStyles} isClearable={false} />
                <span className="field-error">{validations.assignee}</span>
              </Col>
              <Col sm={6}>
                <div style={{ paddingTop: "6px", paddingBottom: "6px", display: "flex", alignItems: "center", justifyContent: "start", fontSize: "13px", fontWeight: "500", color: "#212129", marginTop: "10px" }}>Duration</div>
                <input type="text" className="input-field" style={{ width: "100%" }} value={duration} onChange={handleChange} onKeyDown={(e) => setLastKey(e.key)} placeholder="HH:MM" />
                <span style={{ fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.duration}</span>
              </Col>
            </Row>
            <Row className="mt-2" style={{ width: "670px" }}>
              <Col xs={12} sm={12}>
                <div className="field-title mb-1">Description</div>
                <textarea type="text" placeholder="Enter here" className="input-field w-100" value={description} onChange={(e) => setDescription(e.target.value)} />
                <span className="field-error">{validations.length}</span>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input type="checkbox" checked={multipleGatein} onChange={(e) => setmultipleGatein(e.target.checked)} />
                  <span className="field-title"> Multiple Gate-in </span>
                </label>
              </Col>
            </Row>
            <Row className="mt-3" style={{ width: "670px" }}>
              <div className="style-justify-end">
                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                  Cancel
                </div>
                <div className="save-modal-btn style-justify-center" onClick={submitPurposeVisit}>
                  {povId != null ? "Update " : "Save "}
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurposeVisitCreateModal;
